import React, { Component } from "react";
import { connect } from "react-redux";

import { Get } from "utils/axios";
import { requestError, requestSuccess } from "utils/requestHandler";

const HOC = (WrappedComponent) => {
	class WithHOC extends Component {
		state = {
			loading: false,
			filterQuery: null,
		};

		onChangeHOC = (key, val) => this.setState({ [key]: val });

		load = (param) => this.setState({ loading: param });

		downloadReport = (querystring = "") => {
			Get(
				`/report-generate/xlsx/commission?${querystring?.slice(1) || ""}`,
				this.downloadReportSuccess,
				this.downloadReportError,
				this.load
			);
		};

		downloadReportPdf = (querystring = "") => {
			Get(
				`/report-generate/pdf/commission?${querystring?.slice(1) || ""}`,
				this.downloadReportSuccess,
				this.downloadReportError,
				this.load
			);
		};

		searchCommissionReport = (
			querystring = "",
			page = 1,
			onSuccess = () => {},
			onError = () => {}
		) => {
			const currentPage = Number.isInteger(page) && page > 0 ? page : 1;
			const limit = 10;
			const offset = (currentPage - 1) * limit;
			const baseQuery = querystring?.slice(1) || "";
			const suffix = `${baseQuery ? `${baseQuery}&` : ""}limit=${limit}&offset=${offset}`;
			Get(
				`/reports/commission?${suffix}`,
				(payload) => onSuccess(payload),
				(error) => {
					requestError(error);
					onError(error);
				},
				this.load
			);
		};

		searchCommissionAgents = (keyword, onSuccess, onError = () => {}) => {
			if (!keyword) {
				onSuccess([]);
				return;
			}

			Get(
				`/reports/agents/lookup?search=${encodeURIComponent(keyword)}`,
				(payload) => {
					const rows = Array.isArray(payload?.data) ? payload.data : [];
					const options = rows.map((item) => ({
						value: item.id,
						label: item.code ? `${item.name} (${item.code})` : item.name,
						name: item.name,
						code: item.code,
					}));
					onSuccess(options);
				},
				(error) => {
					requestError(error);
					onError(error);
				},
				() => {}
			);
		};

		downloadReportSuccess = (payload) => {
			requestSuccess(payload.message);
			window.open(payload.ossUrl, "_blank");
		};

		downloadReportError = (error) => requestError(error);

		render = () => {
			return (
				<WrappedComponent
					{...this.props}
					onLoad={this.state.loading}
					downloadReport={this.downloadReport}
					downloadReportPdf={this.downloadReportPdf}
					searchCommissionReport={this.searchCommissionReport}
					searchCommissionAgents={this.searchCommissionAgents}
					onChangeHOC={this.onChangeHOC}
				/>
			);
		};
	}
	const mapStateToProps = (state) => ({ data: state });
	return connect(mapStateToProps)(WithHOC);
};

export default HOC;
